import { createPaginatedSlice } from "../../helpers/reduxHelper";

const profilePreferences = createPaginatedSlice('profilePreferences');

export const profilePreferencesActions = profilePreferences.actions
export const profilePreferencesSelector = state => state.profilePreferences;
export const profilePreferencesReducer = profilePreferences.reducer;
export default profilePreferencesReducer

export const profilePreferencesSelectors = profilePreferences.LF.selectors